import request from '../utils/request.js'
// 问诊记录
export function getUserMemberPageListByUserNo(data) {
    return request({
        url: '/user-tracking/wx/userAskInfo/getUserMemberPageListByUserNo',
        method: 'post',
        data
    })
}
// 问诊详情
export function getAskDetail(data) {
    return request({
        url: '/user-service/askinfo/member/askDetail',
        method: 'get',
        params: data
    })
}
// 查看问诊处方
export function getPrescriptions(data) {
    return request({
        url: '/user-tracking/wx/doctorPrescription/getPrescriptionsByAskNo',
        method: 'post',
        data
    })
}
// 查看三因反馈
export function getThreeCauseReturn(data) {
    return request({
        url: '/user-tracking/wx/userThreeConditionQuestion/getThreeCauseReturnByAskNo',
        method: 'post',
        data
    })
}
// 查看聊天记录
export function getInterrogationChatRecord(data) {
    return request({
        url: '/user-tracking/wx/userAskDetail/getInterrogationChatRecord',
        method: 'post',
        data
    })
}
// 患者信息、患者详情
export function getPatientDetails(data) {
    return request({
        url: '/user-service/member/getPatientDetailsById',
        method: 'get',
        params: data
    })
}
// 修改备注
export function updatePatientDetails(data) {
    return request({
        url: '/user-tracking/wx/userMember/modifyRemark',
        method: 'post',
        data
    })
}
// 跟进提醒列表
export function getTrackRemindList(data) {
    return request({
        url: '/user-tracking/wx/efficacyTrackRemind/pageList',
        method: 'post',
        data
    })
}
// 修改提醒消息为已读
export function remindIsRead(data) {
    return request({
        url: '/user-tracking/wx/efficacyTrackRemind/remindIsRead',
        method: 'post',
        data
    })
}
// 新增疗效跟进记录
export function efficacyTrackSave(data) {
    return request({
        url: '/user-tracking/wx/efficacyTrack/save',
        method: 'post',
        data
    })
}
// 编辑疗效跟进记录
export function efficacyTrackUpdate(data) {
    return request({
        url: '/user-tracking/wx/efficacyTrack/update',
        method: 'post',
        data
    })
}
// 疗效跟进列表
export function selectByCondition(data) {
    return request({
        url: '/user-tracking/wx/efficacyTrack/selectByCondition',
        method: 'post',
        data
    })
}
// 上传文件
export function uploadOther(data) {
    return request({
        url: '/file-service/file/uploadOther',
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data
    })
}

export function getMemberhealth(data) { //获取用户健康
    return request({
        url: '/user-service/app/memberhealth/seeHealth',
        method: 'get',
        params: data
    })
}

export function getMemberHealthTagList(data) { //获取用户健康选项
    return request({
        url: '/user-service/app/memberhealth/memberHealthTagList',
        method: 'get',
        params: data
    })
}

export function setMemberHealthUpdate(data) { //用户健康保存
    return request({
        url: '/user-service/app/userMember/update',
        method: 'post',
        data
    })
}


export function getDiseaseType(data) { //获取病种
    return request({
        url: '/misc-service/typeInfo/detail',
        method: 'get',
        params: {
            typeCode: 'DISEASE_TYPE',
            ...(data || {})
        }
    })
}

export function getAskinfo(data) { //问诊获取
    return request({
        url: '/user-service/app/askinfo/getByAskNoOne',
        method: 'get',
        params: data
    })
}

export function setAskinfo(data) { //问诊保存
    return request({
        url: '/user-service/app/askinfo/modifyAsk',
        method: 'put',
        data
    })
}

export function getAskIllnessYears() { //患病多久获取
    return request({
        url: '/misc-service/dict/getChooseListByCode/ILLNESS_YEARS',
        method: 'get'
    })
}

export function getLogistics(data) { //获取物流信息
    return request({
        url: '/order-service/order/getLogisticsDetails/' + data.askNo,
        method: 'get'
    })
}
export function getLogistic(data) { //获取物流信息
    return request({
        url: `/order-service/app/order/package/${data.askNo}/${data.type}`,
        method: 'get'
    })
}
export function getLogisticsDetails(data) { //获取物流信息
    return request({
        url: `/order-service/app/order/logistics_details/${data.id}/${data.singleNumber}/${data.express}/${data.senderMobile}`,
        method: 'get'
    })
}
export function getIcd(data) { //获取icd
    return request({
        url: '/doctor-service/doctormg/prescription/icdSearch',
        method: 'get',
        params: data
    })
}

export function setInquiryClose(askNo, data) { //关闭问诊
    return request({
        url: '/user-service/doctormg/askinfo/userEndAsk/' + askNo,
        method: 'put',
        data,
        headers: {
            'Content-Type': 'application/json'
        }
    })
}

export function getMedicalRecord(data) { // 获取病历
    return request({
        url: '/user-service/doctormg/emr/generatingEMR',
        method: 'get',
        params: data
    })
}

export function getAskPrescription(data) { // 获取问诊处方
    return request({
        url: '/doctor-service/prescription/getAskPrescription',
        method: 'get',
        params: data
    })
}

export function getMedicationPeriod() { // 获取用药周期
    return request({
        url: '/misc-service/typeInfo/detail',
        method: 'get',
        params: {
            typeCode: 'TM_PERIOD_TYPE'
        }
    })
}

export function getThreeFactorsList() {
    // 获取三阴列表数据
    return request({
        url: "/user-service/userThreeConditionQuestionApply/questionList",
        method: "post",
        data: {},
        headers: {
            "content-type": "application/json",
        },
    });
}

/**
 * 获症状树
 * @returns Promise<any>
 */
export function getSymptomTree() {
    return request({
        url: '/hospital-infrastructure-service/symptom/api/symptomTree',
        method: 'get',
        headers: {
            "content-type": "application/json",
        }
    })
}

/**
 * 获取拨打电话参数
 * @returns Promise<any>
 */
export function getOlaSysData() {
    return request({
        url: '/misc-service/traffic/call/cfg',
        method: 'get',
    })
}


/**
 * 获取问诊健康档案
 * @returns Promise<any>
 */
export function getAskHealthData(params) {
    return request({
        url: '/user-service/doctormg/askinfo/health',
        method: 'get',
        params
    })
}
